import { render, staticRenderFns } from "./taxdecision.vue?vue&type=template&id=05ce6a6c&"
import script from "./taxdecision.vue?vue&type=script&lang=js&"
export * from "./taxdecision.vue?vue&type=script&lang=js&"
import style0 from "./taxdecision.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports